<template>
    <div v-if="stage" class="px-4">
        <!-- <v-row v-if="screen_data && screen_data.templates">{{screen_data.templates}}</v-row> -->
        <v-row>
            <v-col>
                <template>
                    <v-select
                        v-model="stage.workflow_template_id"
                        :items="availableWorkflows"
                        label="Elige un workflow"
                        item-text="name"
                        item-value="id"
                        outlined
                        hide-details="auto"
                    />
                </template>
                <!-- <v-text-field
                    v-model="stage.workflow_template_id"
                    label="Id del workflow"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.workflow_template_id"
                    @change="computeStage">
                </v-text-field> -->
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="list_chosen?'10':'12'">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta al payload: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.payload_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage"
                    @changed_list_situation="update_list_chosen">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col v-if="list_chosen" cols="2" >
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" style="display: inline-block; width: 100%">
                            <v-checkbox
                                v-model="stage.iterate"
                                label="Iterar"
                                hide-details>
                            </v-checkbox>
                        </div>
                    </template>
                    <span style="max-width: 200px; white-space: normal; display: block;">
                        Iterar elemento a elemento, devuelve una lista de resultados.
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="display: inline-block; width: 100%">
                        <v-select
                          v-model="stage.entity_type_id"
                          :items="available_types"
                          label="Tipo de salida"
                          item-text="name"
                          item-value="uuid"
                          outlined
                          hide-details="auto"
                        />
                      </div>
                    </template>
                    <span style="max-width: 350px; white-space: normal; display: block;" v-if="stage.entity_type_id">
                        {{available_types.find(t => t.uuid === stage.entity_type_id).schema}}
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.save_as_key"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { RunWorkflow } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
import { WorkflowTemplateListScreenData } from "@/modules/document/domain/WorkflowTemplateListScreenData";
import { WorkflowTemplateListComponent } from "@/modules/document/application/WorkflowTemplateListComponent";
import { ApiWorkflowTemplateRepository } from "@/modules/document/infra/ApiWorkflowTemplateRepository";

export default {
    name:'RunWorkflowDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: RunWorkflow,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        },
        available_types: {
            type: Array,
            default: () => []
        },
        availableWorkflows: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            list_chosen: false,
        }
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        },
        update_list_chosen(new_list_situation){
            this.list_chosen = new_list_situation;
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>